
import { GetExeImg, UploadFile } from "../request";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { caijiMixin } from "./take-photos-video/caijiMixin";
import { getOptions } from "../common";
import SubTitle from "./title-sub.vue";
import Title from "./title.vue";
@Component({
  components: {
    Title,
    SubTitle,
  },
})
export default class Name extends mixins(caijiMixin) {
  @Prop()
  private content: any; // 整个content数据
  @Watch("content", { immediate: true })
  private contentChange() {
    if (this.content) {
      this.cContent = JSON.parse(JSON.stringify(this.content));
    }
  }
  @Prop()
  private index: any; // 当前题目的索引
  @Prop()
  private data: any; // 题目的数据
  @Watch("data", { immediate: true })
  private dataChange() {
    if (this.data) {
      this.c = JSON.parse(JSON.stringify(this.data));
    }
  }
  @Prop()
  private source: any; //dialog,审核修改弹框;renkouxue,人口学和受试者信息;
  private getOption(key: any) {
    return getOptions(key);
  }

  // 面色和唇色改变,因为有联动，所以需要特殊处理下
  private changeMianChun(e: any, type: any) {
    if (type == "面色") {
      this.cContent.report["面色唇色参数"][3][0] = e;
      this.$forceUpdate();
    } else if (type == "唇色") {
      this.cContent.report["面色唇色参数"][3][6] = e;
      this.$forceUpdate();
    }
    this.$emit("updateContent", this.cContent);
  }
}
